import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import useDimensions from "react-cool-dimensions"
import debounce from "lodash.debounce"

import { setWindowSize } from "app/static/frontend/sheets/sheet-action-creators"

import Sheet from "app/static/frontend/sheets/components/Sheet"

import { decodeStyles } from "app/static/frontend/imports/styleHelperFunctions"
import sheetVars from "app/static/stylus/sheets-variables.json"
import { MantineSheet } from "app/static/frontend/sheets/components/MantineSheet"

const sheetsVariables = decodeStyles(sheetVars)

const debouncedActionCreator = debounce((actionCreator) => actionCreator(), 200, {
    leading: true,
    trailing: true,
})

// NEW PROTOTYPE SHIT HERE

/*
Teaches the sheet component how to resize to its surroundings
When receiving the prop show_map, this component will update and resize
to accomadate the change in vertical space depending on if the map should
be shown or not
The getHeight() and getWidth functions make containerHieght and containerWidth available
in the components props
 */

export function ResponsiveSheet({ containerHeight, containerWidth, setWindowDimensions, ...rest }) {
    const { observe, width, height } = useDimensions()

    useEffect(() => {
        // we do this so that tables will correctly
        // recompute their dimensions and size correctly.
        // https://stackoverflow.com/a/49071358
        let event = ""
        if (typeof Event === "function") {
            event = new Event("resize")
        } else {
            event = document.createEvent("Event")
            event.initEvent("resize", true, true)
        }
        window.dispatchEvent(event)

        debouncedActionCreator(setWindowDimensions)
    }, [setWindowDimensions])

    return (
        <div ref={observe} style={{ height: "100%" }}>
            {!rest.isResourceTable && !rest.publicSheet ? (
                <MantineSheet
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...rest}
                    width={width}
                    height={height}
                />
            ) : (
                <Sheet
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...rest}
                    width={width}
                    height={height}
                    isMobile={width < sheetsVariables.MAX_MOBILE_WIDTH}
                />
            )}
        </div>
    )
}

ResponsiveSheet.propTypes = {
    containerHeight: PropTypes.number,
    containerWidth: PropTypes.number,
    setWindowDimensions: PropTypes.func,
}

export default connect(null, { setWindowDimensions: setWindowSize })(ResponsiveSheet)
